import { render } from "./CommentItemComponent.vue?vue&type=template&id=0e430a66&ts=true"
import script from "./CommentItemComponent.vue?vue&type=script&lang=ts"
export * from "./CommentItemComponent.vue?vue&type=script&lang=ts"

import "./CommentItemComponent.vue?vue&type=style&index=0&id=0e430a66&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__